import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  userOTPs: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the userOTPs
export const fetchUserOTPs = createAsyncThunk(
  "fetchUserOTPs/userOTPs",
  async ({ enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`/user-otp`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create userOTP
export const createUserOTP = createAsyncThunk(
  "createUserOTP/userOTPs",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`/user-otp`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update userOTP
export const updateUserOTP = createAsyncThunk(
  "updateUserOTP/userOTPs",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`/user-otp/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete userOTP
export const deleteUserOTP = createAsyncThunk(
  "deleteUserOTP/userOTPs",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`/user-otp/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const userOTPslice = createSlice({
  name: "userOTP",
  initialState,
  extraReducers: (builder) => {
    // TODO: create userOTP
    builder.addCase(fetchUserOTPs.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchUserOTPs.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.userOTPs = action.payload;
    });

    builder.addCase(fetchUserOTPs.rejected, (state, action) => {
      console.log(action.payload.error, "error");
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          JSON.stringify(
            action.payload.error ||
              action.payload.error.errors ||
              action.payload.error.message
          ),
          {
            variant: "error",
          }
        );
    });

    // TODO: create userOTP
    builder.addCase(createUserOTP.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createUserOTP.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userOTPs.data = [action.payload.data, ...state.userOTPs.data];
      state.userOTPs.meta.total = state.userOTPs.meta.total + 1;
      action.payload.enqueueSnackbar("UserOTP is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createUserOTP.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update userOTP
    builder.addCase(updateUserOTP.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateUserOTP.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userOTPs.data = state.userOTPs.data.map((userOTP) => {
        if (userOTP.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return userOTP;
        }
      });
      action.payload.enqueueSnackbar("UserOTP is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateUserOTP.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete userOTP
    builder.addCase(deleteUserOTP.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteUserOTP.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userOTPs.data = state.userOTPs.data.filter(
        (userOTP) => userOTP.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("UserOTP is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteUserOTP.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default userOTPslice.reducer;
